/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, List } from 'immutable';

const clearDealFiles = (state) => state.clear().set('deleted', new List());

const fileData = (data) =>
  new Map().set('raw', data).set('name', data.meta.regNumber);

const storeFilesToState = (state, data, type) =>
  state.set(type, new List(data.map(fileData))).set('deleted', new List());

const addFileToStore = (state, data, fileType) => {
  const fd = fileData(data);
  if (state.get(fileType)) {
    return state.set(fileType, state.get(fileType).push(fd));
  }
  return state.set(fileType, new List().push(fd));
};

const updateFileInStore = (state, data, type, idx) =>
  state.set(type, state.get(type).set(idx, fileData(data)));

const storeDeletedFile = (state, type, uuid, idx) => {
  const filesStored = state.get(type);
  if (uuid) {
    return state.set(type, filesStored.delete(idx))
      .set('deleted', state.get('deleted').push(uuid));
  }
  return state.set(type, filesStored.delete(idx));
};

export const dealsFilesReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'CLEAR_DEAL':
      return clearDealFiles(state, action.dealType);
    case 'FILES_LOADED':
      return storeFilesToState(state, action.files, action.fileType, action.dealType);
    case 'FILE_ADDED':
      return addFileToStore(state, action.file, action.fileType, action.dealType);
    case 'FILE_UPDATED':
      return updateFileInStore(state, action.file, action.fileType, action.idx, action.dealType);
    case 'FILE_DELETED':
      return storeDeletedFile(state, action.fileType, action.uuid, action.idx, action.dealType);
    case 'RESET_FILE_STORE':
      return state.set(action.fileType, new List());
    default:
      return state;
  }
};

export const deleteFile = (dispatch, fileType, uuid, idx) =>
  dispatch({ type: 'FILE_DELETED', fileType, uuid, idx });

export const updateFile = (dispatch, file, fileType, idx) =>
  dispatch({ type: 'FILE_UPDATED', file, fileType, idx });

export const storeFiles = (dispatch, files, fileType) =>
  dispatch({ type: 'FILES_LOADED', files, fileType });

export const addFile = (dispatch, file, fileType) =>
  dispatch({ type: 'FILE_ADDED', file, fileType });

export const resetFileStore = (dispatch, fileType) =>
  dispatch({ type: 'RESET_FILE_STORE', fileType });
